var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-application",
    {
      staticClass: "si-quotes-view",
      attrs: {
        layout: "full",
        translations: _vm.translations,
        row: "",
        grow: "",
      },
    },
    [
      _vm.title
        ? _c("div", {
            staticClass: "insety-16",
            domProps: { textContent: _vm._s(_vm.title) },
          })
        : _vm._e(),
      _c("SiQuotes"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }